import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { TextField, Typography, Button, Tooltip } from '@mui/material';
import axios from '../../utils/fvAxios';
import "./Myaccount.css";
import Divider from '@mui/material/Divider';

import { useTranslation } from "react-i18next";
import "../../Localization/i18n";
import apiinfo from "../../utils/base-uri.json";
import GetfVDateFormate from "../../utils/Genaricfunctions";

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from "@mui/material/IconButton";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { HasPermissions } from "../../utils/Token";
import INFO from "../../utils/Enums.json";

export default function Security(props) {

    const { t } = useTranslation();

    const validationSchema = Yup.object().shape({
        CurrentPassword: Yup.string()
            .required('Current password is required !'),
        NewPassword: Yup.string()
            .required('New password is required !')
            .matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{10,}$/, 'Minimum 10 characters, at least one upper case letter, one lower case letter, one number and one special character'),
        ConfirmPassword: Yup.string()
            .required('Confirm password is required !')
            .oneOf([Yup.ref('NewPassword'), null], 'Confirm password does not match !'),

    });

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });


    const onSubmit = (data) => {
        let item = {
            oldPassword: data.CurrentPassword,
            newPassword: data.NewPassword,
            confirmPassword: data.ConfirmPassword,
        };
        axios.post(apiinfo.myAccounts.changePassword, item)
            .then(res => {
                if (res?.data?.responseCode == 100) {
                    toast.success(res?.data?.responseMessage, {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
                else {
                    toast.error(res?.data?.responseMessage, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
            });
    };


    const [values, setValues] = React.useState({
        password: '',
        showPassword: false,
        showNewPassword: false,
        showConfirmPassword: false
    });
    const handleClickShowPassword = () => {
        setValues({
            ...values,
            showPassword: !values.showPassword,
        });
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleClickShowPassword1 = () => {
        setValues({
            ...values,
            showNewPassword: !values.showNewPassword
        });
    };
    const handleMouseDownPassword1 = (event) => {
        event.preventDefault();
    };

    const handleClickShowPassword2 = () => {
        setValues({
            ...values,
            showConfirmPassword: !values.showConfirmPassword
        });
    };
    const handleMouseDownPassword2 = (event) => {
        event.preventDefault();
    };
    return (
        <>
            <div className='form'>
                <ToastContainer />
                <label className='personal-info-heading'><b>{t('Security.security')}</b></label> {error && <div className="text-center" style={{ color: "red" }}>{error}</div>}
                <div className='personal-info-subheading'>
                    <span>{t('Security.last')}: {props.date ? GetfVDateFormate("", props.date) : "No Changes"}</span>
                </div>
                <Divider className='mt-3' />
                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Security.currentpassword')} <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <FormControl sx={{ width: '300px' }} variant="outlined">
                            <OutlinedInput
                                autoComplete='new-password'
                                id="CurrentPassword"
                                size='small'
                                sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                    width: "320px"
                                }}
                                type={values.showPassword ? 'text' : 'password'}
                                inputProps={{ className: "login-password" }}
                                // error={errors.firstName ? true : false}
                                {...register("CurrentPassword")}
                                placeholder={t('Security.currentpassword')}
                                variant="outlined"
                                required
                                endAdornment={
                                    <InputAdornment position="end" sx={{
                                        '&$focused $notchedOutline': {
                                            borderColor: '#2EFF22',
                                            borderWidth: 1,
                                        },
                                    }}>
                                        <IconButton
                                            id="outlined-basic"
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {values.showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        {/* <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            required
                            type="password"
                            id="CurrentPassword"
                            name="CurrentPassword"
                            placeholder={t('Security.currentpassword')}
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('CurrentPassword')}
                        /> */}

                        <p className='text-danger mx-2 mt-1'>
                            {errors.CurrentPassword?.message}
                        </p>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>
                <Divider className='mt-3' />
                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Security.newpassword')} <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">

                        <Tooltip
                            placement="left-start"
                            title={
                                <div >
                                    <h6><div class='controlHintText'>Your password must meet the following requirements:<br />At least 10 characters long<br />Contain at least 1 uppercase letter<br />Contain at least 1 lowercase letter<br />Contain at least 1 number <br />Contain at least 1 special character</div></h6>
                                </div>
                            }
                            arrow
                        >
                            <FormControl sx={{ width: '300px' }} variant="outlined">
                                <OutlinedInput
                                    id="NewPassword"
                                    size='small'
                                    sx={{
                                        "& legend": { display: "none" },
                                        "& fieldset": { top: 0 },
                                        width: "320px"
                                    }}
                                    type={values.showNewPassword ? 'text' : 'password'}
                                    inputProps={{ className: "login-password" }}
                                    // error={errors.firstName ? true : false}
                                    {...register("NewPassword")}
                                    placeholder={t('Security.newpassword')}
                                    variant="outlined"
                                    required
                                    endAdornment={
                                        <InputAdornment position="end" sx={{
                                            '&$focused $notchedOutline': {
                                                borderColor: '#2EFF22',
                                                borderWidth: 1,
                                            },
                                        }}>
                                            <IconButton
                                                id="outlined-basic"
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword1}
                                                onMouseDown={handleMouseDownPassword1}
                                                edge="end"
                                            >
                                                {values.showNewPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </Tooltip>
                        {/* <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            required
                            type="password"
                            id="NewPassword"
                            name="NewPassword"
                            placeholder={t('Security.newpassword')}
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('NewPassword')}
                        /> */}

                        <p className='text-danger mx-2 mt-1' >
                            {errors.NewPassword?.message}
                        </p>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>
                <Divider className='mt-3' />
                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Security.confirmpassword')} <small style={{ color: "red" }}>*</small> </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">

                        <FormControl sx={{ width: '300px' }} variant="outlined">
                            <OutlinedInput
                                id="ConfirmPassword"
                                size='small'
                                sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                    width: "320px"
                                }}
                                type={values.showConfirmPassword ? 'text' : 'password'}
                                inputProps={{ className: "login-password" }}
                                // error={errors.firstName ? true : false}
                                {...register("ConfirmPassword")}
                                placeholder={t('Security.confirmpassword')}
                                variant="outlined"
                                required
                                endAdornment={
                                    <InputAdornment position="end" sx={{
                                        '&$focused $notchedOutline': {
                                            borderColor: '#2EFF22',
                                            borderWidth: 1,
                                        },
                                    }}>
                                        <IconButton
                                            id="outlined-basic"
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword2}
                                            onMouseDown={handleMouseDownPassword2}
                                            edge="end"
                                        >
                                            {values.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        {/* <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            required
                            type="password"
                            id="ConfirmPassword"
                            name="ConfirmPassword"
                            placeholder={t('Security.confirmpassword')}
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('ConfirmPassword')}
                        /> */}

                        <p className='text-danger mx-2 mt-1' >
                            {errors.ConfirmPassword?.message}
                        </p>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>

                    <div className='row mt-3 mb-3'>
                        <div className='text-right'>
                            {HasPermissions(INFO?.Screens?.ChangePassword, INFO?.ScreenPermissions?.Modify) && <Button
                                variant="contained"
                                color="primary"
                                sx={{ padding: "15px", textTransform: "capitalize" }}
                                value={loading ? "loading..." : "save"}
                                onClick={handleSubmit(onSubmit)}>
                                {t('Security.save')}
                            </Button>
                            }
                        </div>
                    </div>

                </div>
            </div>

        </>
    )
}